import { createBrowserHistory } from "history";
// Because doesn't work with SSR, must cache at runtime.
let historyCache;
export default function getHistory() {
    if (!historyCache) historyCache = createBrowserHistory();
    return historyCache;
};
